import React from 'react';
import cx from 'classnames';
import {Text, Button, Flex} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {Loader} from '..';
import {isRTL} from '../../../../Localization';

type Props = {
    text: string;
    btnText: string;
    loading?: boolean;
    btnHandler: () => void;
    componentClasses?: string;
};

export const FormMessage = (props: Props) => {
    return (
        <div className={cx(styles.component, props.componentClasses)}>
            <Text skin="paragraph-2" textColor="primary-700">
                {props.text}
            </Text>
            <Button
                skin="secondary"
                onClick={props.btnHandler}
                componentClasses={cx(styles.btn, {[styles.hasLoader]: props.loading})}
            >
                <Flex>
                    <Text
                        skin="paragraph-2"
                        componentClasses={cx(styles.text, {[styles.textOrder]: !isRTL()})}
                    >
                        {props.btnText}
                    </Text>
                    {props.loading && <Loader componentClasses={styles.loader} />}
                </Flex>
            </Button>
        </div>
    );
};
